var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpacity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2289)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77 18.54C13.6135 18.54 17.54 14.6135 17.54 9.77C17.54 4.92646 13.6135 1 8.77 1C3.92646 1 0 4.92646 0 9.77C0 14.6135 3.92646 18.54 8.77 18.54Z",
    fill: "#2682FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M14.88 23.85C19.6407 23.85 23.5 19.9907 23.5 15.23C23.5 10.4693 19.6407 6.60999 14.88 6.60999C10.1193 6.60999 6.26001 10.4693 6.26001 15.23C6.26001 19.9907 10.1193 23.85 14.88 23.85Z",
    fill: "#C6E2E7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_2289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77 18.54C13.6135 18.54 17.54 14.6135 17.54 9.77C17.54 4.92646 13.6135 1 8.77 1C3.92646 1 0 4.92646 0 9.77C0 14.6135 3.92646 18.54 8.77 18.54Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_2289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.69 13.44L17.85 14.28L11.04 7.40998L12.24 6.97998L18.69 13.44Z",
    fill: "#2682FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.84 15.29L16 16.13L8.81 8.93995L9.73 8.19995L16.84 15.29Z",
    fill: "#2682FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.99 17.14L14.14 17.99L7.14996 10.99L7.85996 9.97998L14.99 17.14Z",
    fill: "#2682FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.13 19L12.29 19.84L6.16998 13.65L6.51998 12.39L13.13 19Z",
    fill: "#2682FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 22.86,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpacity);
export default __webpack_public_path__ + "static/media/opacity.a5b74cddd723e4a332d37d8b3b5e022d.svg";
export { ForwardRef as ReactComponent };